import moment from 'moment';
import { PT, React, fetchApi } from '@gasbuddy/react';
import { Table, Header, Button, Modal, Form, Input, Icon, TextArea, Popup, Grid } from 'semantic-ui-react';

export class NoteTable extends React.Component {
  state = {
    localNotes: [],
  }

  onChange = (field, value) => {
    this.setState({ [field]: value });
  }

  saveNote = () => {
    this.setState({ loading: true }, async () => {
      const { id, type } = this.props;
      const { localNotes, summary, detail } = this.state;
      const { body: note } = await fetchApi({
        url: `/audit/note/${type}/${id}`,
        catchErrors: true,
        body: {
          summary,
          detail,
        },
      });
      // TODO clear the fields?
      this.setState({
        loading: false,
        opened: false,
        localNotes: [
          { ...note, value: { summary, detail } },
          ...localNotes,
        ],
      });
    });
  }

  render() {
    const { notes } = this.props;
    const { localNotes, opened, loading, summary, detail } = this.state;
    const allNotes = [
      ...localNotes,
      ...notes || [],
    ];

    const buttonTrigger = (
      <Button
        content="Add Note"
        size="mini"
        icon="add"
        floated="right"
        onClick={(e) => { e.preventDefault(); this.setState({ opened: true }); }}
      />
    );

    return (
      <Grid.Column>
        <Header as="h3" block attached="top" style={{ flex: 0 }}>
          Notes
          <Modal
            open={opened}
            trigger={buttonTrigger}
          >
            <Header content="Add a Note" />
            <Modal.Content>
              <Form loading={loading}>
                <Form.Field>
                  <Input
                    name="summary"
                    value={summary}
                    onChange={(e, { value }) => this.onChange('summary', value)}
                    placeholder="Note Summary"
                  />
                </Form.Field>
                <Form.Field>
                  <TextArea
                    name="detail"
                    value={detail}
                    onChange={(e, { value }) => this.onChange('detail', value)}
                    placeholder="Details"
                  />
                </Form.Field>
              </Form>
            </Modal.Content>
            <Modal.Actions>
              <Button basic color="grey" onClick={() => this.setState({ opened: false })}>
                <Icon name="minus" />
                {' '}
Cancel
              </Button>
              <Button basic color="red" onClick={this.saveNote}>
                <Icon name="sticky note" />
                {' '}
Save Note
              </Button>
            </Modal.Actions>
          </Modal>
        </Header>
        <div className="ui attached segment">
          {allNotes
            && (
            <Table basic="very" selectable style={{ tableLayout: 'fixed', fontSize: '0.9em' }}>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell width={3} textAlign="center">Date</Table.HeaderCell>
                  <Table.HeaderCell width={3} textAlign="center">By</Table.HeaderCell>
                  <Table.HeaderCell>Subject</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {allNotes.map(n => (
                  <Popup
                    wide="very"
                    on="click"
                    trigger={(
                      <Table.Row>
                        <Table.Cell>{moment(n.created_at).format('M/DD/YY HH:mm')}</Table.Cell>
                        <Table.Cell textAlign="center">{n.actor.description}</Table.Cell>
                        <Table.Cell>{n.value?.summary}</Table.Cell>
                      </Table.Row>
)}
                    content={n.value?.detail}
                  />
                ))}
              </Table.Body>
            </Table>
            )
          }
        </div>
      </Grid.Column>
    );
  }
}

NoteTable.propTypes = {
  id: PT.number.isRequired,
  type: PT.string.isRequired,
  notes: PT.arrayOf(PT.shape({
    created_at: PT.string,
    value: PT.object,
    actor: PT.shape({
      description: PT.string,
    }),
  })),
};

NoteTable.defaultProps = {
  notes: [],
};
